import { distance3d as i } from "./index5.js";
function o(t) {
  let r = 0;
  for (let e = 0; e < t.length - 1; e++)
    r += i(t[e], t[e + 1]);
  return r;
}
export {
  o as getPolygonPerimeter
};
//# sourceMappingURL=index16.js.map
